import CbInitializer from "./../services/cb-initializer.js";

var CBStyleConfig = {};
CBStyleConfig.install = function(Vue, options){

  var fetchColor = function() {
    return CbInitializer.styleConfig && CbInitializer.styleConfig.color ? CbInitializer.styleConfig.color : "#0071FF";
  }

  var mobileIndicatorElement = document.getElementById('mobile-indicator');
  var common = {
    computed: {
      backgroundColor() {
        return {
          'background-color': fetchColor()
        }
      },
      themeColor() {
        return {
          'color': fetchColor()
        }
      },
      brandLogo() {
        return CbInitializer.styleConfig && CbInitializer.styleConfig.image.url
      },
      logoPosition() {
        if(CbInitializer.styleConfig && CbInitializer.styleConfig.image.align){
          return CbInitializer.styleConfig.image.align == "center" ? "align-center" : "align-left";
        }
        return "align-left";
      },
      isMobile() {
        return window.getComputedStyle(mobileIndicatorElement).display == "block";
      }
    }
  }

  Vue.mixin(common);
};

export default CBStyleConfig;


// WEBPACK FOOTER //
// ./src/plugins/style-config.js